module.exports = __webpack_public_path__ + "img/flag-red.4bb361e0.svg";